import type { StartupPolicySettings } from "@evolution/shared";
export function validStartupPolicy(value: unknown): value is StartupPolicySettings {
  if (!value || typeof value !== "object") return false;
  const item = value as Partial<StartupPolicySettings>;
  return typeof item.enabled === "boolean" && typeof item.applyAtStartup === "boolean" && typeof item.allowCellular === "boolean"
    && Number.isInteger(item.checkIntervalMinutes) && item.checkIntervalMinutes! >= 0 && item.checkIntervalMinutes! <= 1440
    && Number.isInteger(item.downloadTimeoutSeconds) && item.downloadTimeoutSeconds! >= 15 && item.downloadTimeoutSeconds! <= 90;
}
